import 'react-app-polyfill/ie11';
import 'babel-polyfill';
import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import CreateDistributionKeyApp from './components/create-distribution-key-app';
import CreateAppLicenseApp from './components/create-app-license-app'
import MyLicenses from './components/my-licenses'
import MySupport from './components/my-support/my-support'
import Authentication from './components/authentication';
import ForgotPassword  from './components/forgot-password';
import RecoverAccount from './components/recover-account';
import ChangePassword from './components/change-password';
import MyProfile from './components/my-profile';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      LicenseID:null,
      UserID:null
    }
  }
  
  //Grab data elements off of the root element, passed by server, before rendering.
  componentWillMount(){
    let init_values = document.getElementById('root').dataset;
    this.setState({
      LicenseID: init_values.licenseid || null,
      UserID: init_values.userid || null,
      view: init_values.view,
      subview: init_values.subview || null,
      error: init_values.error || null,
      InEU: (()=>{
        return (init_values.ineu ==="true" || init_values.ineu === "") ? true:false
      })()
    })
  }
  render() {
    switch(this.state.view)
    {
      case 'my-licenses':
        return (
          <div>
            <MyLicenses UserID={this.state.UserID} />
          </div>
        );
      case "create-distribution-key":
        return (
          <div>
            <CreateDistributionKeyApp LicenseID={this.state.LicenseID} UserID={this.state.UserID} />
          </div>
        );
      case "my-support":
        return(
          <div>
            <MySupport UserID={this.state.UserID} View={this.state.subview} InEU={this.state.InEU} />
          </div>
        )
      case "authentication":
        return(
          <>
           <Authentication/>
          </>
        )
      case "forgot-password":
        return(
          <>
           <ForgotPassword/>
          </>
        )
      case "change-password":
        return(
          <>
           <ChangePassword/>
          </>
        )
      case "recover-account":
        return(
          <>
           <RecoverAccount error={this.state.error} UserID={this.state.UserID}/>
          </>
        )
      case "my-profile":
        return(
          <>
          <MyProfile/>
         </>
        )
      default:
      return(
          <div>
            <CreateAppLicenseApp LicenseID={this.state.LicenseID} UserID={this.state.UserID} />
          </div>
      );
    }
    
  }
}

export default App;
